module.exports = __webpack_public_path__ + "static/media/porte7.54d03029.jpg";